import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { AddIcon } from '../../../../components/Icon';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '18.25rem',
    minWidth: '12rem',
    height: '5.438rem',
    borderRadius: '0.9375rem',
    border: '0.0625rem dashed #7d86a9',
    textTransform: 'inherit',
    '&:hover': {
      backgroundColor: '#eef2f9',
    },
  },
  rootwhite: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '18.313rem',
    minWidth: '12rem',
    height: '16.875rem',
    borderRadius: '0.9375rem',
    border: '0.0625rem dashed #7d86a9',
    margin: '0 0 1.875rem 1.25rem',
    textTransform: 'inherit',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  body: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    fontSize: '1.438rem',
    color: theme.palette.font.sub,
    marginRight: '0.813rem',
  },
  text: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
  },
}));

export default function CreateCard({ Click, text, hover }) {
  const classes = useStyles();
  function hoverColor(props) {
    const color = Boolean(props);
    if (color) {
      return classes.rootwhite;
    }
    return classes.root;
  }
  return (
    <Button className={hoverColor(hover)} onClick={Click} id="DutyAssign-Button-aft">
      <div className={classes.body}>
        <AddIcon className={classes.icon} />
        <div className={classes.text}>{text}</div>
      </div>
    </Button>
  );
}
